export default __webpack_public_path__ + "icon_list_view.640e2cd9cdae8f1823d8326394640d3f.svg";